<template>
  <v-menu
    left
    bottom
    offset-y
    transition="slide-y-transition"
    :close-on-content-click="false"
  >
    <template #activator="{ on: onMenu }">
      <v-tooltip bottom>
        <template #activator="{ on: onTooltip }">
          <v-btn icon v-on="{ ...onMenu, ...onTooltip }" @click.stop="">
            <v-icon>today</v-icon>
          </v-btn>
        </template>
        <span>Calendari - {{ today | moment("DD [de] MMMM [de] YYYY") }}</span>
      </v-tooltip>
    </template>

    <v-date-picker
      v-model="picker"
      :first-day-of-week="1"
      locale="ca-ES"
      readonly
      no-title
    >
      <v-spacer />
      Avui - {{ today | moment("DD [de] MMMM [de] YYYY") }}
      <v-spacer />
    </v-date-picker>
  </v-menu>
</template>

<script>
export default {
  data: () => ({
    picker: new Date().toISOString().substr(0, 10),
    today: new Date().toISOString().substr(0, 10),
  }),
}
</script>

<style lang="scss" scoped></style>
